import { atom } from "recoil";
import { SortationStateKey } from "../SortationStateKeys";

export const sortationFeatureClientState = atom<boolean>({
  key: SortationStateKey.SORTATION_FEATURE_CLIENT_STATE,
  default: false,
});
